"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isInvitation(object) {
    return checkInvitation(object).fulfilled;
}
exports.isInvitation = isInvitation;
function checkInvitation(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasChoice("resourceType", ["company", "project"]), __1.hasString("resourceId"), __1.hasNumber("creationDate").integer(), __1.hasString("creatorId"), __1.hasString("inviteeEmail"), __1.hasMap("context", __1.isAny()).optional(), __1.hasChoice("state", ["open", "read", "accepted", "declined"]), __1.hasNumber("expirationDate").integer().optional(), __1.hasString("link").optional()).withOptions(options).explain();
}
exports.checkInvitation = checkInvitation;
//# sourceMappingURL=Invitation.js.map